import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { z } from 'zod';

import { Button, Input, Label } from '@workspace/shadcn';
import { resetPasswordViaEmail } from '@workspace/ui';

import { AuthShell } from '../../components/auth-shell.tsx';
import { auth } from '../../firebase.tsx';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const mutation = useMutation({
    mutationKey: ['reset-password'],
    mutationFn: async () => {
      if (!z.string().email().safeParse(email).success) {
        throw new Error('Enter a valid email address');
      }
      await resetPasswordViaEmail(auth, email);
    },
    onSuccess: () => navigate('/reset-password-email-sent'),
  });

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter the email you signed up with and we will send you a reset link."
      backTo="/signin"
      backLabel="Back to sign in"
    >
      <form
        className="mt-6 space-y-4"
        onSubmit={(event) => {
          event.preventDefault();
          mutation.mutate();
        }}
      >
        <div className="grid w-full items-center gap-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="you@example.com"
          />
          {mutation.isError && (
            <p className="text-destructive text-sm">
              {mutation.error instanceof Error
                ? mutation.error.message
                : 'Could not send the reset link'}
            </p>
          )}
        </div>

        <Button
          type="submit"
          className="w-full"
          disabled={mutation.isPending || !email}
        >
          {mutation.isPending ? 'Sending...' : 'Send reset link'}
        </Button>
      </form>
    </AuthShell>
  );
}
